<!--<form #primaryFieldConfigurationForm="ngForm" *ngIf="!isLoading" (ngSubmit)="onSubmit(primaryFieldConfigurationForm)">-->
<div class="primary-field-config-container">
  <mat-form-field>
    <mat-label>Level</mat-label>
    <mat-select matInput name="Level" [(ngModel)]="primaryFieldConfiguration.MultiItemLevel" (selectionChange)="levelSelectionChanged()" id="multi-level-dropdown">
      @for (l of multiItemLevels; track l) {
        <mat-option [value]="l" id="multi-level-dropdown-{{l.FieldId}}">
          {{ l.DefaultName | translate: 'Text' | async }}
        </mat-option>
      }
    </mat-select>
    <mat-hint>Select a multi-level control.</mat-hint>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Driving Field</mat-label>
    <mat-select matInput name="DrivingField" [(ngModel)]="primaryFieldConfiguration.DrivingField" (selectionChange)="drivingFieldSelectionChanged()" id="driving-field-dropdown">
      @for (field of drivingFields; track field) {
        <mat-option [value]="field" id="driving-field-dropdown-{{field.FieldId}}">
          {{ field.DefaultName | translate: 'Text' | async }}
        </mat-option>
      }
    </mat-select>
    <mat-hint>Select a control.</mat-hint>
  </mat-form-field>
</div>

<div class="mainContent">
  <div class="field-group">
    @if (primaryFieldConfiguration.DrivingField.FieldId) {
      <div class="float-table">
        @for (fieldGroup of moduleService.fieldGroups; track index($index, fieldGroup); let first = $first) {
          <div class="headers sticky" [class.not-first]="!first">
            @if (primaryFieldConfiguration.DrivingField.FieldId) {
              <div class="field-name">
                <!--<span>{{field.FieldName}}</span>-->
                <span>{{fieldGroup.UiGroupName | translate: 'Text' | async}}</span>
              </div>
            }
            @for (listValue of drivingFieldValues; track listValue; let y = $index; let yisOdd = $odd; let yisEven = $even) {
              <div class="list-values"
                [class.odd]="yisOdd"
                [class.even]="yisEven">
                <div class="rotate"><span [title]="listValue.Text">{{listValue.Text}}</span></div>
              </div>
            }
          </div>
          @for (field of availableFields; track field; let s = $index; let sisOdd = $odd; let sisEven = $even) {
            <div class="rows">
              <div [class.field-odd]="sisOdd"
                [class.field-even]="sisEven">
                <div>
                  <span>{{ field.FieldName | translate: 'Text' | async }}</span>
                </div>
              </div>
              @for (drivingFieldValue of drivingFieldValues; track drivingFieldValue; let d = $index; let disOdd = $odd; let disEven = $even) {
                <div [class.odd]="disOdd"
                  [class.even]="disEven">
                  <span class="mod-col">
                    <button mat-mini-fab class="toggle primary"
                      color="white"
                      (click)="togglePrimaryField(field, drivingFieldValue)"
                      [disabled]="false"
                      [ngClass]="{'active': getPrimaryFieldState(field, drivingFieldValue)}"
                      title="Toggle Primary Field"
                      id="primary-field-toggle-{{field.FieldId}}-{{drivingFieldValue.Value}}">
                      <mat-icon aria-label="Toggle Primary"></mat-icon>
                    </button>
                  </span>
                </div>
              }
            </div>
          }
        }
      </div>
    }
  </div>
</div>
<!--</form>-->